/* Tidel: bulk quote request modal. Not part of Ella.

   Submits Shopify's native contact form over fetch so the modal can show a
   success state without a page reload.

   SPAM PROTECTION: if the store has captcha enabled for contact forms, Shopify
   serves a challenge instead of accepting the POST. We cannot satisfy that from
   fetch, so when the response does not come back as a success we fall back to a
   normal form submit — the browser then handles the challenge exactly as Shopify
   intends. That path reloads the page and returns with ?contact_posted=true,
   which we detect on load to reopen the modal on its success state. So the
   captcha keeps working; it just costs a reload when it fires. */
(function () {
  'use strict';

  var FORM = '.tidel-quote-form';
  var FLAG = 'tidelQuote';

  function setup(form) {
    if (form.dataset[FLAG]) return;
    form.dataset[FLAG] = '1';

    var modal = form.closest('modal-dialog');
    var body = modal && modal.querySelector('[data-tidel-quote-body]');
    var success = modal && modal.querySelector('[data-tidel-quote-success]');
    var error = form.querySelector('[data-tidel-quote-error]');
    var submit = form.querySelector('[type="submit"]');
    var submitText = form.querySelector('[data-tidel-quote-submit-text]');
    var qty = form.querySelector('[name="contact[Quantity]"]');

    function showError(message) {
      if (!error) return;
      error.textContent = message;
      error.hidden = false;
    }

    function clearError() {
      if (error) error.hidden = true;
    }

    function valid() {
      clearError();
      // Native constraint validation covers required + email format.
      if (typeof form.reportValidity === 'function' && !form.reportValidity()) return false;
      if (qty && (parseInt(qty.value, 10) < 1 || isNaN(parseInt(qty.value, 10)))) {
        showError('Please enter a quantity of 1 or more.');
        qty.focus();
        return false;
      }
      return true;
    }

    function showSuccess() {
      if (body) body.hidden = true;
      if (success) {
        success.hidden = false;
        success.focus && success.focus();
      }
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!valid()) return;

      var busyLabel = 'Sending…';
      var original = submitText ? submitText.textContent : '';
      if (submit) submit.disabled = true;
      if (submitText) submitText.textContent = busyLabel;

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'text/html' },
      })
        .then(function (res) {
          // Shopify redirects to ?contact_posted=true on success.
          if (res.url && res.url.indexOf('contact_posted=true') !== -1) {
            showSuccess();
            return;
          }
          // Anything else (most likely a captcha challenge) -> let the browser
          // submit normally so Shopify can run its own flow.
          form.submit();
        })
        .catch(function () {
          form.submit();
        })
        .finally(function () {
          if (submit) submit.disabled = false;
          if (submitText) submitText.textContent = original;
        });
    });

    /* Keep the SKU current when the shopper switches variant. Ella renders the
       live SKU into [data-sku] .product-info-value (blocks/product-info.liquid);
       if that block is not on the page we keep the Liquid-rendered value. */
    function syncSku() {
      var source = document.querySelector('[data-sku] .product-info-value');
      if (!source) return;
      var value = (source.textContent || '').trim();
      if (!value) return;
      var field = form.querySelector('[data-tidel-quote-sku]');
      var label = modal && modal.querySelector('[data-tidel-quote-sku-text]');
      if (field) field.value = value;
      if (label) label.textContent = 'SKU ' + value;
    }

    if (modal) {
      var open = modal.show && modal.show.bind(modal);
      if (open) {
        modal.show = function (opener) {
          syncSku();
          return open(opener);
        };
      }
    }
  }

  function boot() {
    var forms = document.querySelectorAll(FORM);
    for (var i = 0; i < forms.length; i++) setup(forms[i]);

    /* Came back from the non-JS / captcha fallback submit: reopen on success. */
    if (window.location.search.indexOf('contact_posted=true') !== -1) {
      var done = document.querySelector('[data-tidel-quote-success]:not([hidden])');
      var dialog = done && done.closest('modal-dialog');
      if (dialog && typeof dialog.show === 'function') {
        var bodyEl = dialog.querySelector('[data-tidel-quote-body]');
        if (bodyEl) bodyEl.hidden = true;
        dialog.show();
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
